export const realEstateNavItems = {
  services: 'Services',
  landPlot: 'Terrain',
};

export const realEstateSecondDescription =
  "Notre objectif est de vous aider à trouver la maison de vos rêves, que vous cherchiez à acheter ou à louer. Nous proposons un large éventail de biens immobiliers dans des lieux et des styles différents, de sorte que vous êtes sûr de trouver quelque chose qui corresponde à vos besoins et à votre budget. Jetez un coup d'œil à nos propriétés ci-dessous ou utilisez la barre de recherche pour trouver un type de propriété ou un emplacement spécifique. Si vous avez besoin d'aide ou si vous avez des questions, n'hésitez pas à nous contacter.";
